import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import waveformSrc from '../../assets/images/slide/mic-waves.png';
import styles from './ProductSlideContent.css';

function ProductSlideContent({
    cardLabel = 'Question 4',
    cardQuestion = 'What did your mother want to be before she had children?',
    titlePrefix = '"There’s nothing to tell"',
    titleAccent = 'is the saddest lie she believes.',
    description = 'Ask broadly, and she’ll insist her dreams didn’t matter. Ask one specific question, and a lifetime unlocks in seconds.'
}) {
    return (
        <div className={styles.form}>
            <div className={styles.cardStack}>
                <div className={styles.cardBehind2} />
                <div className={styles.cardBehind1} />
                <div className={styles.card}>
                    <p className={styles.cardLabel}>{cardLabel}</p>
                    <p className={styles.cardQuestion}>{cardQuestion}</p>
                    <div className={styles.divider} />
                    <div className={styles.recordingUi}>
                        <div className={styles.micButton}>
                            <Icon name='mic' className={styles.micIcon} />
                        </div>
                        <img src={waveformSrc} alt='' className={styles.waveform} />
                    </div>
                </div>
            </div>
            <h2 className={styles.heading}>
                {titlePrefix} <span className={styles.highlight}>{titleAccent}</span>
            </h2>
            <p className={styles.description}>{description}</p>
        </div>
    );
}

ProductSlideContent.propTypes = {
    cardLabel: PropTypes.node,
    cardQuestion: PropTypes.node,
    titlePrefix: PropTypes.node,
    titleAccent: PropTypes.node,
    description: PropTypes.node
};

export {
    ProductSlideContent
};
